module.exports = __webpack_public_path__ + "static/media/rssblack.a895ced5.png";